import React from 'react';
import { get } from 'lodash';
import { FieldArray, useFormikContext } from 'formik';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import ListResource from '../lists/ListResource.jsx';
import FieldArrayCards from './FieldArrayCards.jsx';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';

const FieldsBadgessList = ({}) => {
  const api = '/api/site/badges';
  const ctx = useFormikContext();
  const arr = get(ctx.values, 'badges', []);
  return (
    <>
      <FieldArray name="badges">
        {(helper) => (
          <>
            <div className="row">
              <div className="col">Click badge to add</div>
            </div>
            <div className="row">
              <div className="col card p-3 m-3">
                <ListResource
                  {...{
                    searchable: true,
                    api,
                    sort: { name: 1 },
                    filter: {
                      active: true,
                      type: 'REWARD',
                    },
                    actions: {
                      create: false,
                      remove: false,
                    },
                    onRowClick: (row) => {
                      const included = arr.map((r) => r._id);

                      if (!included.includes(row._id)) {
                        helper.push(row);
                      }
                    },
                    cols: [
                      {
                        key: 'name',
                        sortable: true,
                        children: 'Name',
                      },
                      {
                        key: 'description',
                        sortable: true,
                        children: 'Description',
                      },
                    ],
                  }}
                />
              </div>
              <div className="col card p-3 m-3">
                <div className="row">
                  <FieldArrayIterables name="badges">
                    {(s, i, helpers) => (
                      <div className="col-auto justify-content-center align-items-center" key={i}>
                        <button className="btn btn-link close" onClick={() => helpers.remove(i)}>
                          <FA icon={faTimes} size="sm" />
                        </button>
                        <div className="text-center">
                          <img src={s.image} width={100}/>
                        </div>
                        <div className="text-center">
                          {s.name}
                        </div>
                      </div>
                    )}
                  </FieldArrayIterables>
                </div>
              </div>
            </div>
          </>
        )}
      </FieldArray>
    </>
  );
};

export default FieldsBadgessList;
